import React from "react";
import styles from "./CustomCheckbox.module.css";

const CustomCheckbox = ({
  label,
  name,
  value = [],
  onChange,
  options = [],
  required = false,
  disabled = false,
  error,
  inline = true,
  labelClassName = "",
}) => {
  const handleChange = (optionValue, checked) => {
    if (onChange) {
      let newValue;
      if (checked) {
        newValue = [...value, optionValue];
      } else {
        newValue = value.filter((v) => v !== optionValue);
      }
      onChange(newValue);
    }
  };

  // Support single checkbox (backward compatibility)
  const isSingleCheckbox = options.length === 0;

  if (isSingleCheckbox) {
    return (
      <div className={styles.checkboxContainer}>
        <label
          className={`${styles.checkboxLabel} ${disabled ? styles.disabled : ""}`}
        >
          <input
            type="checkbox"
            name={name}
            checked={value}
            onChange={(e) => onChange && onChange(e.target.checked)}
            disabled={disabled}
            className={styles.checkboxInput}
          />
          <span
            className={`${styles.checkmark} ${value ? styles.checked : ""}`}
          >
            {value && (
              <svg
                width="12"
                height="10"
                viewBox="0 0 12 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 5L4.5 8.5L11 1"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </span>
          {label && <span className={styles.labelText}>{label}</span>}
        </label>
        {error && <span className={styles.errorText}>{error}</span>}
      </div>
    );
  }

  // Multiple checkboxes with options
  return (
    <div className={styles.checkboxGroupContainer}>
      {label && (
        <label
          className={`${styles.label} ${labelClassName} ${
            disabled ? styles.labelDisabled : ""
          }`}
        >
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <div
        className={`${styles.checkboxOptions} ${
          inline ? styles.inline : styles.stacked
        }`}
      >
        {options.map((option) => {
          const isChecked = value.includes(option.value);
          const isDisabled = disabled || option.disabled;

          return (
            <label
              key={option.value}
              className={`${styles.checkboxLabel} ${
                isDisabled ? styles.disabled : ""
              }`}
            >
              <input
                type="checkbox"
                name={name}
                value={option.value}
                checked={isChecked}
                onChange={(e) => handleChange(option.value, e.target.checked)}
                disabled={isDisabled}
                className={styles.checkboxInput}
              />
              <span
                className={`${styles.checkmark} ${isChecked ? styles.checked : ""}`}
              >
                {isChecked && (
                  <svg
                    width="12"
                    height="10"
                    viewBox="0 0 12 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 5L4.5 8.5L11 1"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </span>
              <span className={styles.labelText}>{option.label}</span>
            </label>
          );
        })}
      </div>
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default CustomCheckbox;